import type { TeamTheme } from '@mondy/shared';
import { FlagPattern } from './FlagPattern';

/**
 * Discreet team-flag decoration anchored to the top-right of the main
 * content column. Rendered as a child of `<main>` (which has
 * `position: relative`) so it doesn't get covered by the standings rail
 * the way the previous viewport-fixed version did. Rotated and faded to
 * read as painterly chrome, not a uncanny rectangular flag cutout.
 */
export function MainColumnFlag({ theme }: { theme: TeamTheme }) {
  return (
    <div className="main-flag-corner" aria-hidden="true">
      <FlagPattern spec={theme.pattern} />
    </div>
  );
}
